import {
  createFileRoute,
  Outlet,
  useLocation,
  useRouterState,
} from '@tanstack/react-router'
import { RequireAdmin } from '@/components/permissions'
import PageLoading from '@/components/PageLoading'

// Routes under /compliance that should be accessible to all roles (Testers, Reviewers, etc.)
// These are the routes where users perform their assigned work
const PUBLIC_COMPLIANCE_ROUTES = ['/tests/', '/submissions/']

function ComplianceLayout() {
  const location = useLocation()
  const routerState = useRouterState()
  const isNavigatingAway =
    routerState.status === 'pending' &&
    !(routerState.pendingMatches || []).some((m) => m.routeId === Route.id)

  // Check if current route is a public compliance route (accessible to all roles)
  const isPublicComplianceRoute = PUBLIC_COMPLIANCE_ROUTES.some((route) =>
    location.pathname.includes(route)
  )

  // Leaving compliance while next route is still pending - avoid transient 403
  if (isNavigatingAway) {
    return <PageLoading />
  }

  // Public routes don't need admin check
  if (isPublicComplianceRoute) {
    return <Outlet />
  }

  // Admin-only routes (dashboard, setup, policies, etc.)
  return (
    <RequireAdmin resource="compliance">
      <Outlet />
    </RequireAdmin>
  )
}

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/compliance'
)({
  component: ComplianceLayout,
})
